import { Setting } from "./Setting";

export const INITIAL_VALUES: Setting = {
	SettingName: "",
	Value: "",
	Description: "",
};
